Ext.ns('mx.plugin');

mx.plugin.Navigable = function(
    /*{ Namespace function ns(), Ext.Component function container(), String defaultName }*/ config
) {
    Ext.apply(this, config);
};

Ext.extend(mx.plugin.Navigable, Ext.util.Observable, {
    init: function(/*Ext.Component*/ application) {
        var plugin = this;

        Ext.apply(application, {
            /**
             * Fires on history change, executes navigation between screens
             * @param path - array of strings in hash, delimited by /
             */
            navigate: function(path) {
                var name = path.shift();

                var ns = plugin.ns.apply(application);
                if (!ns) return;

                if (!name || name == 'default' || !ns[name] || (ns[name].navigation && ns[name].navigation.disabled)) {
                    name = this.getNavigables()[0] && this.getNavigables()[0].name;
                }

                var container = plugin.container.apply(application); // application viewport || core main mainPanel
                var cmp = container && container.items && container.items.itemAt(0);

                // Remove old component
                if (cmp && cmp.constructor != ns[name]) {
                    container.remove(cmp);
                    cmp = null;
                }

                if (ns[name] && typeof ns[name] == 'function') {
                    // Create new component
                    if (!cmp) {
                        cmp = new ns[name]({
                            id: name + 'Screen',
                            pathPrefix: this.pathPrefix.concat(name),
                        });
                        container.add(cmp);
                    }

                    if (cmp.navigate) {
                        cmp.navigate(path.concat([])); // .concat([]) = .clone()
                    }
                } else {
                    Ext.Msg.alert('404', 'Sorry, such page does not exist');
                }

                application.fireEvent('navigate', name);
            },
            /**
             * Returns an array of buttons, representing all navigables in given namespace
             */
            getNavigables: function() {
                var result = [];

                var ns = plugin.ns();
                if (!ns) return result;

                var container = plugin.container();
                var cmp = container && container.items && container.items.itemAt(0);

                for (var name in ns) {
                    if (typeof ns[name] == 'function') {
                        var navigation = ns[name].navigation;
                        var disabled = navigation ? navigation.disabled : false;
                        if (!disabled) {
                            result.push({
                                title: navigation ? navigation.title : '',
                                position: navigation ? navigation.position : 1000,
                                name: name,
                                href: '#' + this.pathPrefix.concat(name).join(mx.DELIMETER),
                                selected: cmp && cmp.constructor == ns[name],
                                onClick: function(e) {
                                    var container = plugin.container.apply(application);
                                    var cmp = container && container.items && container.items.itemAt(0);
                                    if (cmp && cmp.preventNavigation) {
                                        if (cmp.preventNavigation()) {
                                            var scope = this;
                                            Ext.Msg.confirm(
                                                '',
                                                MXBT.loc('mx.plugin.Navigable', 'preventPageUnloadWarning'),
                                                function(btn) {
                                                    if (btn == 'yes') {
                                                        window.location.hash = scope.getEl().child('a').dom.name;
                                                    }
                                                }
                                            );
                                        } else {
                                            window.location.hash = this.getEl().child('a').dom.name;
                                        }
                                    } else if (cmp && cmp.preventNavigatingAway) {
                                        // another mechanism, that doesn't show confirm box itself
                                        if (cmp.preventNavigatingAway()) {
                                            window.location.hash = this.getEl().child('a').dom.name;
                                        }
                                    } else {
                                        window.location.hash = this.getEl().child('a').dom.name;
                                    }

                                    if (!this.disabled) {
                                        this.fireEvent('click', this, e);
                                        if (this.handler) {
                                            this.handler.call(this.scope || this, this, e);
                                        }
                                    }
                                },
                            });
                        }
                    }
                }
                result.sort(function(a, b) {
                    if (a.position > b.position) return 1;
                    if (a.position < b.position) return -1;
                    return 0;
                });

                return result;
            },
        });

        application.fireEvent('navigable_ready');
    },
});
